/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PostInstructorDto = {
    firstName: string;
    lastName: string;
    bio?: string;
    pronouns?: PostInstructorDto.pronouns;
};
export namespace PostInstructorDto {
    export enum pronouns {
        HE_HIM = 'HE_HIM',
        SHE_HER = 'SHE_HER',
        THEY_THEM = 'THEY_THEM',
        NONE = 'NONE',
    }
}

